import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { postData } from "../../../service/Service";

const initialState = {
  data: {
    dashboard: [],
    dashboardFarmer: [],
  },
  updatedTime: 0,
  isLoading: false,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getReportHarvest = createAsyncThunk(
  "farmer/report/harvest",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/harvest/report",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getReportHarvestFarmer = createAsyncThunk(
  "farmer/farmer/harvest/report/farmer",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/harvest/report/farmer",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);


const reportHarvest = createSlice({
  name: "Report Harvest",
  initialState: initialState,
  extraReducers: {
    [getReportHarvest.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportHarvest.fulfilled]: (state, action) => {
      state.data.dashboard = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportHarvest.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getReportHarvestFarmer.pending]: (state) => {
      state.isLoading = true;
    },
    [getReportHarvestFarmer.fulfilled]: (state, action) => {
      state.data.dashboardFarmer = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getReportHarvestFarmer.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
  },
});

export const reportHarvestActions = reportHarvest.actions;

export default reportHarvest.reducer;
